var _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpark4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 50,
    viewBox: "0 0 135 50",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "0.0, 46.584340514976326 15.0, 46.584340514976326 30.0, 43.95691014188121 45.0, 49.211770888071435 60.0, 50.0 75.0, 49.474513925380975 90.0, 0.0 105.0, 12.427745664739907 120.0, 12.427745664739907",
    fill: "none",
    stroke: "#32ca5b",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark4);
export default __webpack_public_path__ + "static/media/spark4.e248c67882a701943998d0461f398c3a.svg";
export { ForwardRef as ReactComponent };